import { SignInProviderConfig, SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  oktaAuthApiRef,
  useApi,
} from '@backstage/frontend-plugin-api';
import type { SignInPageProps } from '@backstage/plugin-app-react';

const oktaProvider: SignInProviderConfig = {
  id: 'okta-auth-provider',
  title: 'SMG',
  message: 'Okta Swiss marketplace',
  apiRef: oktaAuthApiRef,
};

export const AppSignInPage = (props: SignInPageProps) => {
  const configApi = useApi(configApiRef);
  if (configApi.getString('auth.environment') === 'development') {
    return <SignInPage {...props} providers={['guest']} />;
  }
  return <SignInPage {...props} auto provider={oktaProvider} />;
};
